import { render, staticRenderFns } from "./TopSalesByUser.vue?vue&type=template&id=59354760"
import script from "./TopSalesByUser.vue?vue&type=script&lang=js"
export * from "./TopSalesByUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports